export const actionTypes = {
  SET_PROJECT_ID: 'SET_PROJECT_ID',
  SET_MULTI_BLOCK: 'SET_MULTI_BLOCK',
  SET_TITLE: 'SET_TITLE',
  UPDATE_TITLE: 'UPDATE_TITLE',
  SET_LIST_VOICE: 'SET_LIST_VOICE',
  SET_CREATED_AT: 'SET_CREATED_AT',
  SET_PRODUCT: 'SET_PRODUCT',
  SET_IS_PLAYING: 'SET_IS_PLAYING',
  SET_CURRENT_BLOCK_ID: 'SET_CURRENT_BLOCK_ID',
  SET_VOICE_DEFAULT: 'SET_VOICE_DEFAULT',
  SET_AUDIO_LINK: 'SET_AUDIO_LINK',
  SET_IS_DRAFT: 'SET_IS_DRAFT',
  SET_IS_MULTI_BLOCK_MODE: 'SET_IS_MULTI_BLOCK_MODE',
  ADD_BLOCK: 'ADD_BLOCK',
  UPDATE_BLOCK: 'UPDATE_BLOCK',
  UPDATE_BLOCK_SYNTHESIS_INFO: 'UPDATE_BLOCK_SYNTHESIS_INFO',
  UPDATE_MULTI_BLOCK_SYNTHESIS_INFO: 'UPDATE_MULTI_BLOCK_SYNTHESIS_INFO',
  UPDATE_BLOCK_ELEMENTS: 'UPDATE_BLOCK_ELEMENTS',
  UPDATE_ORDER_BLOCK: 'UPDATE_ORDER_BLOCK',
  DELETE_BLOCK: 'DELETE_BLOCK',
  UPDATE_DURATION: 'UPDATE_DURATION',
  UPDATE_CURRENT_TIME: 'UPDATE_CURRENT_TIME',
  SET_IS_DOWNLOADING: 'SET_IS_DOWNLOADING',
  UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE:
    'UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE',
  UPDATE_ORIGINAL_BLOCKS: 'UPDATE_ORIGINAL_BLOCKS',
  SET_IS_PROJECT_SYNTHESIZING: 'SET_IS_PROJECT_SYNTHESIZING',
  UPDATE_CREDITS_BLOCKS: 'UPDATE_CREDITS_BLOCKS',
  DELETE_CREDITS_BLOCKS: 'DELETE_CREDITS_BLOCKS',
  SET_ORIGINAL_TITLE: 'SET_ORIGINAL_TITLE',
  SET_IS_PLAYING_BLOCK: 'SET_IS_PLAYING_BLOCK',
  SET_CURRENT_PLAYING_BLOCK_ID: 'SET_CURRENT_PLAYING_BLOCK_ID',
  SET_AUDIO_TYPE: 'SET_AUDIO_TYPE',
  SET_OPEN_DIALOG_CHANGE_FORMAT: 'SET_OPEN_DIALOG_CHANGE_FORMAT',
  SAVE_PROJECT: 'SAVE_PROJECT',
  SET_ORIGINAL_AUDIO_TYPE: 'SET_ORIGINAL_AUDIO_TYPE',
};

const setProjectId = (projectId) => ({
  type: actionTypes.SET_PROJECT_ID,
  payload: projectId,
});

const setMultiBlock = (multiBlock) => ({
  type: actionTypes.SET_MULTI_BLOCK,
  payload: multiBlock,
});

const setTitle = (title) => ({
  type: actionTypes.SET_TITLE,
  payload: title,
});

const updateTitle = (title) => ({
  type: actionTypes.UPDATE_TITLE,
  payload: title,
});

const setListVoice = (listVoice) => ({
  type: actionTypes.SET_LIST_VOICE,
  payload: listVoice,
});

const setCreatedAt = (createdAt) => ({
  type: actionTypes.SET_CREATED_AT,
  payload: createdAt,
});

const setProduct = (product) => ({
  type: actionTypes.SET_PRODUCT,
  payload: product,
});

const setIsPlaying = (isPlaying) => ({
  type: actionTypes.SET_IS_PLAYING,
  payload: isPlaying,
});

const setCurrentBlockId = (currentBlockId) => ({
  type: actionTypes.SET_CURRENT_BLOCK_ID,
  payload: currentBlockId,
});

const setVoiceDefault = (voiceDefault) => ({
  type: actionTypes.SET_VOICE_DEFAULT,
  payload: voiceDefault,
});

const setAudioLink = (audioLink) => ({
  type: actionTypes.SET_AUDIO_LINK,
  payload: audioLink,
});

const setIsDraft = (isDraft) => ({
  type: actionTypes.SET_IS_DRAFT,
  payload: isDraft,
});

const setIsMultiBlockMode = (isMultiBlockMode) => ({
  type: actionTypes.SET_IS_MULTI_BLOCK_MODE,
  payload: isMultiBlockMode,
});

const addBlock = (blockId, newBlocks) => ({
  type: actionTypes.ADD_BLOCK,
  payload: { blockId, newBlocks },
});

const updateBlock = (blockId, block) => ({
  type: actionTypes.UPDATE_BLOCK,
  payload: { blockId, block },
});

const updateBlockSynthesisInfo = (blockId, synthesisInfo) => ({
  type: actionTypes.UPDATE_BLOCK_SYNTHESIS_INFO,
  payload: { blockId, synthesisInfo },
});
const updateMultiBlockSynthesisInfo = (blockIds, synthesisInfos) => ({
  type: actionTypes.UPDATE_MULTI_BLOCK_SYNTHESIS_INFO,
  payload: { blockIds, synthesisInfos },
});

const updateBlockElements = (blockId, elements) => ({
  type: actionTypes.UPDATE_BLOCK_ELEMENTS,
  payload: { blockId, elements },
});

const updateOrderBlock = (blockIds) => ({
  type: actionTypes.UPDATE_ORDER_BLOCK,
  payload: blockIds,
});

const deleteBlock = (blockId) => ({
  type: actionTypes.DELETE_BLOCK,
  payload: blockId,
});

const updateDuration = (duration) => ({
  type: actionTypes.UPDATE_DURATION,
  payload: duration,
});

const updateCurrentTime = (currentTime) => ({
  type: actionTypes.UPDATE_CURRENT_TIME,
  payload: currentTime,
});

const setIsDownloading = (isDownloading) => ({
  type: actionTypes.SET_IS_DOWNLOADING,
  payload: isDownloading,
});

const updateBlocksWithPronunciationChange = (pronunciationChange) => ({
  type: actionTypes.UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE,
  pronunciationChange,
});

const updateOriginalBlocks = (blockId) => ({
  type: actionTypes.UPDATE_ORIGINAL_BLOCKS,
  payload: blockId,
});

const setIsProjectSynthesizing = (isProjectSynthesizing) => ({
  type: actionTypes.SET_IS_PROJECT_SYNTHESIZING,
  payload: isProjectSynthesizing,
});

const updateCreditsBlocks = (blockId, credits) => ({
  type: actionTypes.UPDATE_CREDITS_BLOCKS,
  payload: { blockId, credits },
});

const deleteCreditsBlocks = (blockId) => ({
  type: actionTypes.DELETE_CREDITS_BLOCKS,
  payload: { blockId },
});

const setOriginalTitle = (originalTitle) => ({
  type: actionTypes.SET_ORIGINAL_TITLE,
  payload: originalTitle,
});

const setIsPlayingBlock = (isPlayingBlock) => ({
  type: actionTypes.SET_IS_PLAYING_BLOCK,
  payload: isPlayingBlock,
});

const setCurrentPlayingBlockId = (currentPlayingBlockId) => ({
  type: actionTypes.SET_CURRENT_PLAYING_BLOCK_ID,
  payload: currentPlayingBlockId,
});

const setAudioType = (audioType) => ({
  type: actionTypes.SET_AUDIO_TYPE,
  payload: audioType,
});

const setOpenDialogChangeFormat = (openDialogChangeFormat) => ({
  type: actionTypes.SET_OPEN_DIALOG_CHANGE_FORMAT,
  payload: openDialogChangeFormat,
});

const saveProject = () => ({
  type: actionTypes.SAVE_PROJECT,
});

const setOriginalAudioType = (originalAudioType) => ({
  type: actionTypes.SET_ORIGINAL_AUDIO_TYPE,
  payload: originalAudioType,
});

export {
  setProjectId,
  setMultiBlock,
  setTitle,
  updateTitle,
  setListVoice,
  setCreatedAt,
  setProduct,
  setIsPlaying,
  setCurrentBlockId,
  setVoiceDefault,
  setAudioLink,
  setIsDraft,
  setIsMultiBlockMode,
  addBlock,
  updateBlock,
  updateBlockSynthesisInfo,
  updateBlockElements,
  updateOrderBlock,
  deleteBlock,
  updateDuration,
  updateCurrentTime,
  updateMultiBlockSynthesisInfo,
  setIsDownloading,
  updateBlocksWithPronunciationChange,
  updateOriginalBlocks,
  setIsProjectSynthesizing,
  updateCreditsBlocks,
  deleteCreditsBlocks,
  setOriginalTitle,
  setIsPlayingBlock,
  setCurrentPlayingBlockId,
  setAudioType,
  setOpenDialogChangeFormat,
  saveProject,
  setOriginalAudioType,
};
